import name from './name'

const selectSliceData = state => state[name]
const selectIsFetchingTemplateList = state => selectSliceData(state).fetchingTemplateList
const selectTemplateList = state => selectSliceData(state).list
const selectTemplateListSelect = state => selectSliceData(state).listSelect
const selectTotal = state => selectSliceData(state).total
const selectParentTemplatesList = state => selectSliceData(state).parentTemplatesList

export {
  selectIsFetchingTemplateList,
  selectTemplateList,
  selectTemplateListSelect,
  selectTotal,
  selectParentTemplatesList
}
